export const THUMBNAIL_PX_PER_INCH = 5

export const CAMERA_MODE_AUTO = 'auto'
export const CAMERA_MODE_STANDARD = 'standard'
export const CAMERA_MODE_WALL = 'wall'

export const CAMERA_REFERENCE_ART_WIDTH = 50
export const CAMERA_REFERENCE_ART_HEIGHT = 50
export const CAMERA_STANDARD_PADDING = 1.08
export const CAMERA_WALL_PADDING = 1.02

export function toPositiveNumber(value, fallback = null) {
  const parsed = Number(value)
  if (!Number.isFinite(parsed) || parsed <= 0) return fallback
  return parsed
}

export function normalizeCameraMode(value) {
  const mode = String(value || '').trim().toLowerCase()
  if (mode === CAMERA_MODE_STANDARD || mode === CAMERA_MODE_WALL) return mode
  return CAMERA_MODE_AUTO
}
